import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import {
  FilterBarContainer,
  SearchContainer,
  StyledTextField,
  ToggleContainer,
  StyledSwitch,
  StyledToggleButtonGroup,
  StyledToggleButton,
  StyledButtonContainer,
  FullContainer,
  SearchButtonContainer,
} from "./TenderFilterBar.styles";

import { MenuItem, InputLabel } from "@mui/material";
import { StyledSelectContainer, StyledFormControl, StyledSelect } from "./TenderFilterBar.styles";

function EmployerSelect({ value, onChange, employers, ...props }) {
  return (
    <StyledSelectContainer {...props}>
      <StyledFormControl variant="standard" fullWidth>
        <InputLabel id="employer-select-label">Employer</InputLabel>
        <StyledSelect
          labelId="employer-select-label"
          id="employer-select"
          value={value}
          onChange={onChange}
          label="Employer"
        >
          <MenuItem>
            <span style={{ color: "#888" }}>None</span>
          </MenuItem>
          {employers && employers.map((employer) => (
            <MenuItem key={employer.id} value={employer.id}>
              {employer.name}
            </MenuItem>
          ))}
        </StyledSelect>
      </StyledFormControl>
    </StyledSelectContainer>
  );
}

function BrokerSelect({ value, onChange, brokers, ...props }) {
  return (
    <StyledSelectContainer {...props}>
      <StyledFormControl variant="standard" fullWidth>
        <InputLabel id="broker-select-label">Broker</InputLabel>
        <StyledSelect
          labelId="broker-select-label"
          id="broker-select"
          value={value}
          onChange={onChange}
          label="Broker"
        >
          <MenuItem>
            <span style={{ color: "#888" }}>None</span>
          </MenuItem>
          {brokers && brokers.map((broker) => (
            <MenuItem key={broker.id} value={broker.id}>
              {broker.name}
            </MenuItem>
          ))}
        </StyledSelect>
      </StyledFormControl>
    </StyledSelectContainer>
  );
}

export default function TenderFilterBar({ getTenders, employers, brokers }) {
  const [isMyTenders, setIsMyTenders] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState("Active");
  const [searchText, setSearchText] = useState("");
  const [selectedEmployer, setSelectedEmployer] = useState(undefined);
  const [selectedBroker, setSelectedBroker] = useState(undefined);
  const [initialValues, setInitialValues] = useState({
    isMyTenders: true,
    selectedStatus: "Active",
    searchText: "",
    selectedBroker: undefined,
    selectedEmployer: undefined,
  });

  const [isChanged, setIsChanged] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const hasChanged =
      isMyTenders !== initialValues.isMyTenders ||
      selectedStatus !== initialValues.selectedStatus ||
      searchText.trim() !== initialValues.searchText.trim() ||
      selectedEmployer !== initialValues.selectedEmployer ||
      selectedBroker !== initialValues.selectedBroker;

    setIsChanged(hasChanged);
  }, [isMyTenders, selectedStatus, searchText, selectedEmployer, selectedBroker]);

  const handleSearch = async () => {
    const payload = {
      isMyTenders: isMyTenders,
      selectedStatus: selectedStatus,
      searchText: searchText.trim(),
      filteredEmployer: selectedEmployer,
      filteredBroker: selectedBroker,
    };

    try {
      await getTenders(payload);
      setInitialValues({
        isMyTenders,
        selectedStatus,
        searchText: searchText.trim(),
        selectedEmployer: selectedEmployer,
        selectedBroker: selectedBroker,
      });
      setIsChanged(false);
    } catch (error) {
      console.error("Search failed:", error);
    }
  };

  const isSearchEnabled = () => ( isChanged );

  return (
    <FullContainer>
      <FilterBarContainer>
        <SearchContainer data-testid="search-bar">
          <SearchIcon />
          <StyledTextField
            variant="standard"
            placeholder="Search"
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value);
            }}
            InputProps={{ disableUnderline: true }}
          />
        </SearchContainer>

        <EmployerSelect
          data-testid="employer-filter"
          value={selectedEmployer}
          onChange={(e) => setSelectedEmployer(e.target.value)}
          employers={employers}
        />
        <BrokerSelect
          data-testid="broker-filter"
          value={selectedBroker}
          onChange={(e) => setSelectedBroker(e.target.value)}
          brokers={brokers}
        />

        <ToggleContainer data-testid="toggle-my-all">
          <span>All Tenders</span>
          <StyledSwitch
            checked={isMyTenders}
            onChange={() => {
              setIsMyTenders((prev) => !prev);
            }}
          />
          <span>My Tenders</span>
        </ToggleContainer>

        <StyledToggleButtonGroup
          data-testid="status-filter"
          value={selectedStatus}
          exclusive
          onChange={(_, newValue) => {
            if (newValue) {
              setSelectedStatus(newValue);
            }
          }}
        >
          {["All", "Active", "Complete"].map((tab) => (
            <StyledToggleButton key={tab} value={tab} selected={selectedStatus === tab}>
              {tab}
            </StyledToggleButton>
          ))}
        </StyledToggleButtonGroup>

        <SearchButtonContainer
          style={{
            opacity: isSearchEnabled() ? 1 : 0.5,
            pointerEvents: isSearchEnabled() ? "auto" : "none",
          }}
          onClick={isSearchEnabled() ? handleSearch : undefined}
        >
          Search
        </SearchButtonContainer>
      </FilterBarContainer>

      <StyledButtonContainer
        data-testid="start-new-tender"
        onClick={() => navigate("/new-tender")}
      >
        Start New Tender
      </StyledButtonContainer>
    </FullContainer>
  );
}